import { Component, computed, inject, Input, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseModalComponent } from '@card-software/library';
import { DyehouseDailyMetricPreviewResultDto } from '../../../../../models/production/dyehouse-daily-metric.model';

@Component({
  selector: 'app-dyehouse-daily-metric-preview-modal',
  templateUrl: './dyehouse-daily-metric-preview-modal.component.html',
  styleUrl: './dyehouse-daily-metric-preview-modal.component.scss',
})
export class DyehouseDailyMetricPreviewModalComponent extends BaseModalComponent<{ override: boolean }> {
  private readonly translateService = inject(TranslateService);

  @Input() previewResult!: DyehouseDailyMetricPreviewResultDto;

  overrideEnabled = signal(false);

  hasDuplicates = computed(() => this.previewResult.totalDuplicates > 0);
  hasMissing = computed(() => this.previewResult.totalMissingData > 0);

  // missing_data BLOCKS import — both conditions must pass
  canSave = computed(() => !this.hasMissing() && (!this.hasDuplicates() || this.overrideEnabled()));

  getStatusSeverity(status: string): 'success' | 'warn' | 'danger' | 'secondary' {
    switch (status) {
      case 'ok':
        return 'success';
      case 'duplicate':
        return 'warn';
      case 'missing_data':
        return 'danger';
      default:
        return 'secondary';
    }
  }

  getStatusLabel(status: string): string {
    switch (status) {
      case 'ok':
        return this.translate('DyehouseDailyMetric.status_ok', 'OK');
      case 'duplicate':
        return this.translate('DyehouseDailyMetric.status_duplicate', 'Duplicate');
      case 'missing_data':
        return this.translate('DyehouseDailyMetric.status_missing_data', 'Missing Data');
      default:
        return status;
    }
  }

  private translate(key: string, fallback: string): string {
    const result = this.translateService.instant(key);
    return result !== key ? result : fallback;
  }

  onConfirm(): void {
    this.close({ action: 'save', data: { override: this.overrideEnabled() } });
  }

  onCancel(): void {
    this.close({ action: 'close', data: { override: false } });
  }
}
